<template>
	<section class="container-form">
		<div class="box-edit">
			<div class="row-edit">
				<b-field expanded label="Email:" custom-class="is-small">
					<b-input v-model="formData.email" expanded placeholder="seuemail@exemplo.com" />
				</b-field>
				<b-field expanded label="Email NFCE:" custom-class="is-small">
					<b-input v-model="formData.emailnfe" expanded placeholder="seuemail@exemplo.com" />
				</b-field>
			</div>
			<div class="row-edit">
				<b-field expanded label="Email RCA:" custom-class="is-small">
					<b-input v-model="formData.emailrca" expanded placeholder="seuemail@exemplo.com" />
				</b-field>
				<b-field expanded label="Código do Representante:" custom-class="is-small">
					<b-input v-model="formData.representante" expanded placeholder="Exemplo: 232323" />
				</b-field>
			</div>
			<div class="row-edit">
				<b-field expanded label="CNAE:" custom-class="is-small">
					<b-input v-model="formData.cnae" expanded placeholder="No label" />
				</b-field>
			</div>
			<div class="row-edit">
				<b-field label="Observação" custom-class="is-small">
					<b-input v-model="formData.observacao" type="textarea" />
				</b-field>
			</div>
			<div class="container-btn">
				<b-button class="btn-form" type="is-primary" size="is-small" outlined @click="updateItem">
					Salvar
				</b-button>
				<b-button class="btn-form" type="is-danger" size="is-small" outlined @click="goBack()">
					Cancelar
				</b-button>
			</div>
		</div>
	</section>
</template>

<script>
import * as ecAxios from '../../util/ecAxios';

export default {
	data() {
		return {
			formData: {},
		};
	},
	created() {
		this.getItemEdit();
	},
	methods: {
		async getItemEdit() {
			await ecAxios
				.connection()
				.get(
					`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO}${this.$route.params.id}`
				)
				.then((response) => {
					this.formData = response.data.usuarioCadastro;
				})
				.catch((e) => {
					this.$buefy.notification.open({
						duration: 5000,
						message: e.toString(),
						position: 'is-bottom-right',
						type: 'is-danger',
						hasIcon: true,
					});
				});
		},
		goBack() {
			if (window.history.length > 1) {
				this.$router.go(-1);
			} else {
				this.$router.push('/');
			}
		},
		success(message) {
			this.$buefy.notification.open({
				message,
				type: 'is-success',
			});
		},
		async updateItem() {
			await ecAxios
				.connection()
				.post(
					`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO_CADASTRO_UPDATE}`,
					this.formData
				)
				.then((response) => {
					if (response.data.error === 0) {
						this.success(response.data.message);
						this.goBack();
					}
				})
				.catch(() => {});
		},
	},
};
</script>

<style lang="scss" scoped>
.container-form {
	background-color: #fff;
	padding: 20px;
	margin-bottom: 50px;
}
.row-edit:nth-child(4) {
	margin-top: 10px;
}
.row-edit {
	display: flex;
	width: 100%;
	justify-content: space-between;
}
.field {
	width: 49%;
}
.container-btn {
	display: flex;
	justify-content: flex-end;
	padding-right: 20px;
}
.btn-form {
	margin-right: 10px;
}
</style>

